import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'hourFilter'
})
export class HourFilterPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return moment("1111-11-11 " + value, "YYYY-MM-DD HH:mm").format("HH:mm");
  }

}
